/**
 * Decide how a paste should be applied, and turn plain text into lines
 * without stacking blank paragraphs.
 */

export function htmlKeepsStructure(html) {
  if (!html) return false;
  if (/<(?:table|ul|ol|h[1-6])\b/i.test(html)) return true;
  const breaks = html.match(/<(?:p|div|br|li|tr|blockquote)\b/gi);
  return !!breaks && breaks.length >= 2;
}

function hasLineBreaks(text) {
  return /[\r\n\u2028\u2029]/.test(text || '');
}

/**
 * A copied dialogue is usually one div or paragraph per line.
 * Quill flattens those wrappers into a single paragraph.
 * When the plain text still has the line breaks, keep those lines
 * unless the clipboard also has a list, table, heading, or inline formatting.
 */
export function shouldPasteAsPlainLines(html, text) {
  if (!hasLineBreaks(text)) return false;
  if (/<(?:table|ul|ol|h[1-6])\b/i.test(html || '')) return false;
  if (/<(?:strong|b|em|i|u|s|a|span)\b/i.test(html || '')) return false;
  return true;
}

export function quillBlocksFromHtml(html) {
  return String(html || '')
    .replace(/<div\b([^>]*)>/gi, '<p$1>')
    .replace(/<\/div>/gi, '</p>')
    .replace(/<br\s*\/?>/gi, '</p><p>');
}

export function plainLinesFromText(text) {
  const normalized = String(text || '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/\u2028|\u2029/g, '\n');
  const lines = [];
  let emptyRun = 0;

  normalized.split('\n').forEach((line) => {
    if (line.trim() === '') {
      emptyRun += 1;
      if (emptyRun === 1 && lines.length > 0) lines.push('');
      return;
    }
    emptyRun = 0;
    lines.push(line);
  });

  while (lines.length && lines[lines.length - 1] === '') lines.pop();
  return lines;
}
